import React from 'react';
import { object, func, bool, string } from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {
  withStyles,
  MuiThemeProvider,
  createTheme,
} from '@material-ui/core/styles';
import { Translation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';
import { Typography } from '@material-ui/core';

const styles = (theme) => ({
  textFielde: {
    marginTop: theme.spacing(1),
    marginBottom: 0,
  },
  button: {
    marginTop: theme.spacing(2),
    backgroundColor: '#357a38',
    color: '#ffffff',
    fontWeight: '600',
  },
  linkButton: {
    marginTop: theme.spacing(2),
  },
  root: {},
  headerContainer: {},
  titleStyle: {},
  subTitle: {},
  itemMidContainer: {},
  footerContainer: {},
  footerBar: {},
  textFooterTerms: {},
  textFooter: {},
  trademarkText: {},
});

const theme = createTheme({
  palette: {
    primary: {
      main: '#6fbf73',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f50057',
      contrastText: '#ffffff',
    },
  },
  typography: {
    useNextVariants: true,
  },
});

const Login = ({
  email,
  emailChanged,
  emailError,
  password,
  passwordChanged,
  passwordError,
  authenticating,
  canLogin,
  login,
  history,
  classes,
  loginError = '',
}) => (
  <Translation>
    {(t) => {
      return (
        <form
          onSubmit={(event) => {
            event.preventDefault();
            login(email, password, history);
          }}
        >
          <div>
            {loginError.length > 0 && (
              <Typography variant="body1" color="error" gutterBottom>
                {t(loginError)}
              </Typography>
            )}
            <TextField
              id="login-email"
              name="email"
              label={t('email')}
              autoComplete="email"
              value={email}
              onChange={(event) => emailChanged(event.target.value)}
              className={classes.textField}
              fullWidth
              error={emailError.length > 0}
              disabled={authenticating}
            />
          </div>
          <div>
            <TextField
              id="login-password"
              label={t('password')}
              autoComplete="current-password"
              type="password"
              value={password}
              onChange={(event) => passwordChanged(event.target.value)}
              className={classes.textField}
              fullWidth
              error={passwordError.length > 0}
              disabled={authenticating}
            />
          </div>
          <div>
            <MuiThemeProvider theme={theme}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                className={classes.button}
                fullWidth
                disabled={authenticating || !canLogin}
              >
                {t('login')}
              </Button>
            </MuiThemeProvider>
          </div>
          <Grid
            className={classes.linkButton}
            container
            spacing={1}
            alignItems="flex-start"
            justifyContent="flex-start"
            direction="column"
          >
            <Grid item xs={12}>
              <Link to="/reset-password">
                <Typography color="primary" variant="subtitle1">
                  {t('forgotPassword')}
                </Typography>
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Link to="/signup">
                <Typography color="primary" variant="subtitle1">
                  {t('registerYet')}
                </Typography>
              </Link>
            </Grid>
          </Grid>
        </form>
      );
    }}
  </Translation>
);
Login.propTypes = {
  classes: object.isRequired,
  email: string.isRequired,
  emailChanged: func.isRequired,
  password: string.isRequired,
  passwordChanged: func.isRequired,
  canLogin: bool.isRequired,
  login: func.isRequired,
  authenticating: bool.isRequired,
  emailError: string,
  passwordError: string,
  loginError: string,
};

export default withStyles(styles)(Login);



// WEBPACK FOOTER //
// ./src/view/forms/Login/LoginForm.js